/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import Total3WMarketPage from 'src/pages/ReportsPages/ReportsBoard/4wPages/Total3WMarketPage'
import boardReportsService from 'src/services/boardReportsService'

const Total3WMarketContainer = () => {
  const [total, setTotals] = useState([])
  const [totaSub, setTotalSub] = useState([])
  const [totalC, setTotalC] = useState([])
  const [gtotal1, setTotal1] = useState([])
  const [totaS2A, setTotalS2A] = useState([])
  const [totaS2B, setTotalS2B] = useState([])
  const [gtotalC3A, setGTotalC3A] = useState([])
  const [gtotalC3B, setGTotalC3B] = useState([])

  const [totalS, setTotalSs] = useState([])
  const [totalSSub, setTotalSSub] = useState([])
  const [totalSC, setTotalSC] = useState([])
  const [gtotalS1, setTotalS1] = useState([])
  const [totalSS2A, setTotalSS2A] = useState([])
  const [totalSS2B, setTotalSS2B] = useState([])
  const [gtotalSC3A, setGTotalSC3A] = useState([])
  const [gtotalSC3B, setGTotalSC3B] = useState([])
 
  const [total7PS, setTotalSsP] = useState([])
  const [totalSSubP, setTotalSSubP] = useState([])
  const [totalSCP, setTotalSCP] = useState([])
  const [gtotalS1P, setTotalS1P] = useState([])
  const [totalSS2AP, setTotalSS2AP] = useState([])
  const [totalSS2BP, setTotalSS2BP] = useState([])
  const [gtotalSC3AP, setGTotalSC3AP] = useState([])
  const [gtotalSC3BP, setGTotalSC3BP] = useState([])

  const [totalSCS, setTotalSCs] = useState([])
  const [totalSCSub, setTotalSCSub] = useState([])
  const [gtotalSC1, setTotalSC1] = useState([])
  const [gtotalSCS2A, setTotalSCS2A] = useState([])
  const [gtotalSCS2B, setTotalSCS2B] = useState([])

  const [totalSCSC, setTotalSCsC] = useState([])
  const [totalSCSubC, setTotalSCSubC] = useState([])
  const [gtotalSC1C, setTotalSC1C] = useState([])
  const [gtotalSCS2AC, setTotalSCS2AC] = useState([])
  const [gtotalSCS2BC, setTotalSCS2BC] = useState([])

  const [selectedDate, setSelectedDate] = useState(new Date())

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadTotal = async () => {
    const [total1, total2, total3, gtotal1, gtotal2A, gtotal2B, gtotal3A, gtotal3B] = await Promise.all([
      boardReportsService.getTotalMarket3WProduct('1', selectedDate.getFullYear()),
      boardReportsService.getTotalMarket3WProduct('2', selectedDate.getFullYear()),
      boardReportsService.getTotalMarket3WProduct('3', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket3WProduct('1', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket3WProduct('2a', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket3WProduct('2b', selectedDate.getFullYear()),
      boardReportsService.getGTotalMarket3WProduct('3a', selectedDate.getFullYear(), 'limite=10'),
      boardReportsService.getGTotalMarket3WProduct('3b', selectedDate.getFullYear(), 'limite=10'),
    ])
    setTotals(total1)
    setTotalSub(total2)
    setTotalC(total3)
    setTotal1(gtotal1)
    setTotalS2A(gtotal2A)
    setTotalS2B(gtotal2B)
    setGTotalC3A(gtotal3A || [])
    setGTotalC3B(gtotal3B || [])
  }

  const reloadTotalSubcategory = async () => {
    const [total1, total2, total3, gtotal1, gtotal2A, gtotal2B, gtotal3A, gtotal3B] = await Promise.all([
      boardReportsService.getTotalMarket3WProduct('4', selectedDate.getFullYear(), 'subcategoria=CARGA'),
      boardReportsService.getTotalMarket3WProduct('6', selectedDate.getFullYear(), 'subcategoria=CARGA'),
      boardReportsService.getTotalMarket3WProduct('5', selectedDate.getFullYear(), 'subcategoria=CARGA'),
      boardReportsService.getGTotalMarket3WProduct('4', selectedDate.getFullYear(), 'subcategoria=CARGA'),
      boardReportsService.getGTotalMarket3WProduct('5a', selectedDate.getFullYear(), 'subcategoria=CARGA'),
      boardReportsService.getGTotalMarket3WProduct('5b', selectedDate.getFullYear(), 'subcategoria=CARGA'),
      boardReportsService.getGTotalMarket3WProduct('6a', selectedDate.getFullYear(), 'subcategoria=CARGA&limite=10'),
      boardReportsService.getGTotalMarket3WProduct('6b', selectedDate.getFullYear(), 'subcategoria=CARGA&limite=10'),
    ])
    setTotalSs(total1 || [])
    setTotalSSub(total2 || [])
    setTotalSC(total3 || [])
    setTotalS1(gtotal1 || [])
    setTotalSS2A(gtotal2A || [])
    setTotalSS2B(gtotal2B || [])
    setGTotalSC3A(gtotal3A || [])
    setGTotalSC3B(gtotal3B || [])
  }

  const reloadTotalSubcategoryp = async () => {
    const [total1, total2, total3, gtotal1, gtotal2A, gtotal2B, gtotal3A, gtotal3B] = await Promise.all([
      boardReportsService.getTotalMarket3WProduct('4', selectedDate.getFullYear(), 'subcategoria=PASAJEROS'),
      boardReportsService.getTotalMarket3WProduct('6', selectedDate.getFullYear(), 'subcategoria=PASAJEROS'),
      boardReportsService.getTotalMarket3WProduct('5', selectedDate.getFullYear(), 'subcategoria=PASAJEROS'),
      boardReportsService.getGTotalMarket3WProduct('4', selectedDate.getFullYear(), 'subcategoria=PASAJEROS'),
      boardReportsService.getGTotalMarket3WProduct('5a', selectedDate.getFullYear(), 'subcategoria=PASAJEROS'),
      boardReportsService.getGTotalMarket3WProduct('5b', selectedDate.getFullYear(), 'subcategoria=PASAJEROS'),
      boardReportsService.getGTotalMarket3WProduct('6a', selectedDate.getFullYear(), 'subcategoria=PASAJEROS&limite=10'),
      boardReportsService.getGTotalMarket3WProduct('6b', selectedDate.getFullYear(), 'subcategoria=PASAJEROS&limite=10'),
    ])
    setTotalSsP(total1 || [])
    setTotalSSubP(total2 || [])
    setTotalSCP(total3 || [])
    setTotalS1P(gtotal1 || [])
    setTotalSS2AP(gtotal2A || [])
    setTotalSS2BP(gtotal2B || [])
    setGTotalSC3AP(gtotal3A || [])
    setGTotalSC3BP(gtotal3B || [])
  }

  const reloadTotalSubcategorySegment = async () => {
    const [total1, total2, gtotal1, gtotal2A, gtotal2B] = await Promise.all([
      boardReportsService.getTotalMarket3WProduct(
        '7',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO SIN CABINA'
      ),
      boardReportsService.getTotalMarket3WProduct(
        '8',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO SIN CABINA'
      ),
      boardReportsService.getGTotalMarket3WProduct(
        '7',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO SIN CABINA'
      ),
      boardReportsService.getGTotalMarket3WProduct(
        '8a',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO SIN CABINA&limite=10'
      ),
      boardReportsService.getGTotalMarket3WProduct(
        '8b',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO SIN CABINA&limite=10'
      ),
    ])
    setTotalSCs(total1 || [])
    setTotalSCSub(total2 || [])
    setTotalSC1(gtotal1 || [])
    setTotalSCS2A(gtotal2A || [])
    setTotalSCS2B(gtotal2B || [])
  }

  const reloadTotalSubcategoryCabinado = async () => {
    const [total1, total2, gtotal1, gtotal2A, gtotal2B] = await Promise.all([
      boardReportsService.getTotalMarket3WProduct(
        '7',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO CABINADO'
      ),
      boardReportsService.getTotalMarket3WProduct(
        '8',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO CABINADO'
      ),
      boardReportsService.getGTotalMarket3WProduct(
        '7',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO CABINADO'
      ),
      boardReportsService.getGTotalMarket3WProduct(
        '8a',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO CABINADO&limite=10'
      ),
      boardReportsService.getGTotalMarket3WProduct(
        '8b',
        selectedDate.getFullYear(),
        'subcategoria=CARGA&segmento=MOTOCARRO CABINADO&limite=10'
      ),
    ])
    setTotalSCsC(total1 || [])
    setTotalSCSubC(total2 || [])
    setTotalSC1C(gtotal1 || [])
    setTotalSCS2AC(gtotal2A || [])
    setTotalSCS2BC(gtotal2B || [])
  }

  useEffect(() => {
    reloadTotal()
    reloadTotalSubcategory()
    reloadTotalSubcategoryp()
    reloadTotalSubcategorySegment()
    reloadTotalSubcategoryCabinado()
  }, [selectedDate])

  return (
    <Total3WMarketPage
      selectedDate={selectedDate}
      handleDateChange={handleDateChange}
      total={total}
      totaSub={totaSub}
      totalC={totalC}
      gtotal1={gtotal1}
      totaS2A={totaS2A}
      totaS2B={totaS2B}
      gtotalC3A={gtotalC3A}
      gtotalC3B={gtotalC3B}
      totalS={totalS}
      totalSSub={totalSSub}
      totalSC={totalSC}
      gtotalS1={gtotalS1}
      totalSS2A={totalSS2A}
      totalSS2B={totalSS2B}
      gtotalSC3A={gtotalSC3A}
      gtotalSC3B={gtotalSC3B}
      totalSCS={totalSCS}
      totalSCSub={totalSCSub}
      gtotalSC1={gtotalSC1}
      gtotalSCS2A={gtotalSCS2A}
      gtotalSCS2B={gtotalSCS2B}
      totalSCSC={totalSCSC}
      totalSCSubC={totalSCSubC}
      gtotalSC1C={gtotalSC1C}
      gtotalSCS2AC={gtotalSCS2AC}
      gtotalSCS2BC={gtotalSCS2BC}
      totalSP={total7PS}
      totalSSubP={totalSSubP}
      totalSCP={totalSCP}
      gtotalS1P={gtotalS1P}
      totalSS2AP={totalSS2AP}
      totalSS2BP={totalSS2BP}
      gtotalSC3AP={gtotalSC3AP}
      gtotalSC3BP={gtotalSC3BP}
    />
  )
}

export default Total3WMarketContainer
